import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaPaperPlane, FaPlus, FaUpload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import { Form } from '@unform/web';
import Input from '../../../../core/components/Forms/Input';
import { urlWebsite } from '../../../../../../config';

interface ICreateModule {
  lineData: Record<string, any>;
  projectHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

export default function CreateModule({
  lineData,
  projectHash
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();

  const key = uuid();

  const sendEmailTest = async (data) => {

    if (!data?.email) {
      addToast({ title: 'Insira um e-mail válido', type: 'error' })
    }

    if (!lineData?.mail_type) {
      addToast({ title: 'O Tipo de e-mail não foi configurado na campanha', type: 'error' })
    }


    if (lineData?.mail_type === 'Confirmação') {

      try {
        const project = await api.get('/projects', { params: { where: { url: projectHash } } })
        const saleProduct = await api.get('/sales-products', { params: { where: { project_id: projectHash, payment_status_id: 'paid' } } })


        await api.post(`/mailer-confirm-campaign-send-test/${saleProduct?.data?.rows?.[0]?.ticket_hash}/${lineData?._id?.toString()}`, { email: data?.email, imagePath: urlWebsite, website: project?.data?.rows?.[0]?.theme_data?.website_url });
        addToast({ title: 'Agendado com sucesso', type: 'success' });
        removeModal('confirm');
        await reloadSearchAll();
      }
      catch (err) {
        addToast({ title: 'Erro ao agendar', type: 'error' })
      }

    }

    if (lineData?.mail_type === 'Atualização') {
      try {
        const project = await api.get('/projects', { params: { where: { url: projectHash } } })
        const student = await api.get('/students', { params: { limitItems: 1 } })


        await api.post(`/mailer-campaign-update-send-test/${student?.data?.rows?.[0]?.user_hash}/${lineData?._id?.toString()}`, { email: data?.email, imagePath: urlWebsite, website: project?.data?.rows?.[0]?.theme_data?.website_url });
        addToast({ title: 'Enviado com sucesso', type: 'success' });
        removeModal('confirm');
        await reloadSearchAll();
      }
      catch (err) {
        addToast({ title: 'Erro ao agendar', type: 'error' })
      }

    }


    if (lineData?.mail_type === 'Padrão') {
      try {
        const project = await api.get('/projects', { params: { where: { url: projectHash } } })
        const student = await api.get('/students', { params: { limitItems: 1 } })
        const saleProduct = await api.get('/sales-products', { params: { where: { project_id: projectHash, payment_status_id: 'paid' } } })


        await api.post(`/mailer-default-campaign-send-test/${saleProduct?.data?.rows?.[0]?.ticket_hash}/${lineData?._id?.toString()}`, { email: data?.email, imagePath: urlWebsite, website: project?.data?.rows?.[0]?.theme_data?.website_url });
        addToast({ title: 'Enviado com sucesso', type: 'success' });
        removeModal('confirm');
        await reloadSearchAll();
      }
      catch (err) {
        addToast({ title: 'Erro ao agendar', type: 'error' })
      }

    }

  }


  const handleCreate = (): void => {
    const content = <><Form onSubmit={sendEmailTest}>
      <Input name='email' placeholder='E-mail' />
      <button className='greenButton2' >Enviar teste</button>
    </Form>
    </>;
    if (content) {
      const keyModal = addModal({ title: '', content, key, theme: "whiteModal" });
    }
  };

  const moduleCreate = (): JSX.Element => (
    lineData._id ? <button style={{ color: '#fff', background: lineData?.mail_type === 'Confirmação' ? 'purple' : lineData?.mail_type === 'Atualização' ? "orange" : '#333' }} className="lineIcon" title='Enviar Teste' type="button" onClick={handleCreate}>
      <FiMail />
    </button> : <></>
  );

  return moduleCreate();
}
